<template>
    <svg width="31" height="24" viewBox="0 0 31 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.96484 12.0569H29.9275M19.4415 1.36377L29.9275 12.0569L19.4415 22.75" stroke="white"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

</template>